export default {
    getReadWidget:   () => '<in-reference-column field="::field" value="value()" datastore="::datastore"></in-reference-column>',
    getLinkWidget:   () => '<ma-reference-link-column entry="::entry" field="::field" value="::value" datastore="::datastore"></ma-reference-link-column>',
    getFilterWidget: () => '<ma-reference-field field="::field" value="value" datastore="::datastore"></ma-reference-field>',
    getWriteWidget:  () => '<ma-reference-field field="::field" value="value" datastore="::datastore"></ma-reference-field>'
};



// WEBPACK FOOTER //
// ./app/components/common/crud/fieldView/ReferenceFieldView.js